import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DeleteLostAndFoundIssueDocumentInput,
  DeleteLostAndFoundIssueDocumentBulkResponse,
  MutationDeleteLostAndFoundIssueDocumentBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteLostAndFoundIssueDocument } from '@/features/LostAndFoundHistory/api/queries/DeleteLostAndIssueDocument';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteLostAndFoundIssueDocumentInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteLostAndFoundIssueDocumentBulkResponse>;
}

// SearchLostAndFoundIssue Service
export const { deleteLostAndFoundIssueDocument, useDeleteLostAndFoundIssueDocument } = ((): {
  deleteLostAndFoundIssueDocument: ServiceMethod;
  useDeleteLostAndFoundIssueDocument: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteLostAndFoundIssueDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: DeleteLostAndFoundIssueDocumentInput[],
        options?: ConnectionOptions
      ): Promise<DeleteLostAndFoundIssueDocumentBulkResponse> => {
        const args: MutationDeleteLostAndFoundIssueDocumentBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteLostAndFoundIssueDocumentBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteLostAndFoundIssueDocumentBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteLostAndFoundIssueDocument: fetch,
    useDeleteLostAndFoundIssueDocument: useService,
  };
})();
